import { browserLocalPersistence, setPersistence } from 'firebase/auth';
import type { User } from 'firebase/auth';
import { initializeDashboardAccess } from '../DashboardAuth';
import { auth } from '../firebase';
import { clearSignupDraft } from './SignupDraft';

// Confirm that server-owned access resolves to the newly provisioned clinic
// before making the signup session durable or discarding its recovery draft.
export const prepareProvisionedDashboardSession = async (
    user: User,
    expectedProviderId: string,
    signupDraftId?: string | null
): Promise<void> => {
    if (!expectedProviderId) {
        throw new Error('The new clinic is missing its dashboard reference. Please try again.');
    }
    const access = await initializeDashboardAccess(user, user.email);
    if (access.providerId !== expectedProviderId) {
        throw new Error('Dashboard access resolved to a different clinic. Please contact SuperPenguin support.');
    }
    await setPersistence(auth, browserLocalPersistence);
    clearSignupDraft(signupDraftId);
};

// Reload so the dashboard initializes against the newly selected or provisioned identity.
export const reloadDashboard = (path = '/'): void => {
    window.location.replace(path);
};
